
import {buildPagination} from "./buildPagination.js";

export function grabDatabaseCharacters(response){
  
    var characterDetailsArray ;
    var charactersCollectionArray = [];


    try{    
        var charactersDataRetrieved = response.data.data.results;
        charactersDataRetrieved.forEach(function(item,index){
            
            //remove the () that sometimes show up in characters names. 
            //example: Sabretooth (Age of Apocalypse)
            var name = response.data.data.results[index].name;
            
            if(name.indexOf('(') != -1){
                //var finalName = name.substring(0, name.lastIndexOf('(') + 0);
                var finalName = response.data.data.results[index].name;
            }
            else{
                var finalName = response.data.data.results[index].name
            }


            var finalCharacterImage;
           //replace marvels shitty "image not found" image with mine
           if(response.data.data.results[index].thumbnail.path === "http://i.annihil.us/u/prod/marvel/i/mg/b/40/image_not_available"){
                finalCharacterImage = "http://www.webnamehere.com/jarvis/images/character-not-found.gif";
            }
            else{
                finalCharacterImage = response.data.data.results[index].thumbnail.path + "." +response.data.data.results[0].thumbnail.extension;
            }



            //im storing the total of all characters marvels API finds for pagination purposes
            //ill store it in each character bc i dont want to restructure this array
            characterDetailsArray = [
                finalName,
                response.data.data.results[index].description,
                finalCharacterImage,
                response.data.data.results[index].id,
                response.data.data.total
            ]

            charactersCollectionArray.push(characterDetailsArray);
        });//end charactersDataRetrieved.forEach()

        //just grab the first items 'total' value. 
        //pass it into buildPagination() along with how many characters will show on the page
        var total = charactersCollectionArray[0][4];
        var pagination = buildPagination(24,total);
        
        charactersCollectionArray.push(pagination);
        //console.log(charactersCollectionArray);

    }//end try
    catch(error) {
        console.log("Couldnt grab a character in grabCharacters.js" + error);
    }

 
    return charactersCollectionArray;

}//end grabCharacters()


// WEBPACK FOOTER //
// ./src/components/includes/grabDatabaseCharacters.js